<template>
    <Fragment>
        <VueScene
                ref="fade_out"
                :keyframes="keyframes_fadeout"
                :autoplay=false
                @ended="onFadedOut">
            <span></span>
        </VueScene>
        <VueScene
                ref="fade_in"
                :keyframes="keyframes_fadein"
                :autoplay=false>
            <span></span>
        </VueScene>
        <div class="apppage audiopage" id="audiopage" :style="showContent? 'display:block':'display: none'">

            <div class="instruction">2. select up to three audio layers</div>

            <div class="audiooptions">
                <div :class="choices.indexOf('bones')!==-1? 'audiooption selected' : 'audiooption'"
                     @click="onChoose('bones')">
                    bones
                </div>
                <div :class="choices.indexOf('flesh')!==-1? 'audiooption selected' : 'audiooption'"
                     @click="onChoose('flesh')">
                    flesh
                </div>
                <div :class="choices.indexOf('skin')!==-1? 'audiooption selected' : 'audiooption'"
                     @click="onChoose('skin')">
                    skin
                </div>
            </div>

            <div class="headphones" v-if="!isMobile()"><i class="fal fa-headphones-alt"></i> headphones recommended</div>

            <div class="info" v-if="!isMobile()">{{info}}</div>

            <div class="audiopreviews">
                <AudioPreview
                        ref="preview_bones"
                        @play-pressed="onPlayPreviewAudio('bones')"
                        @stop-pressed="onStopPreviewAudio"
                        filename="Bones_extract.mp3"
                        :playing="preview_playing_bones" />
                <AudioPreview
                        ref="preview_flesh"
                        @play-pressed="onPlayPreviewAudio('flesh')"
                        @stop-pressed="onStopPreviewAudio"
                        filename="Flesh_extract.mp3"
                        :playing="preview_playing_flesh" />
                <AudioPreview
                        ref="preview_skin"
                        @play-pressed="onPlayPreviewAudio('skin')"
                        @stop-pressed="onStopPreviewAudio"
                        filename="Skin_extract.mp3"
                        :playing="preview_playing_skin" />
            </div>

            <button class="back_btn" @click="$emit('back-clicked')">
                <i class="fal fa-arrow-left"></i>
            </button>

            <button class="wizard_btn" @click="onNextClicked" :disabled='this.choices.length === 0'>
                create film
            </button>

        </div>
    </Fragment>

</template>

<script>

    import { VueScene } from "vue-scenejs";
    import { Fragment } from 'vue-fragment'
    import AudioPreview from "@/components/AudioPreview";

    export default {
        name: 'AudioPage',
        components:{
            AudioPreview,
            VueScene,
            Fragment
        },
        methods:{
            onChoose: function(choice) {
                var idx = this.choices.indexOf(choice);
                if(idx == -1){
                    this.choices.push(choice);
                } else {
                    this.choices.splice(idx, 1);
                }

                this.$emit('choose-audio', this.choices.sort().join('+'));
            },
            onFadedOut: function() {
                this.showContent = false;
            },
            onNextClicked: function() {
                this.preview_playing_skin = false;
                this.preview_playing_flesh = false;
                this.preview_playing_bones = false;
                this.$emit('next-clicked');
            },
            onPlayPreviewAudio: function(ref) {
                this.preview_playing_skin = ref === "skin";
                this.preview_playing_flesh = ref === "flesh";
                this.preview_playing_bones = ref === "bones";
            },
            onStopPreviewAudio: function() {
                this.preview_playing_skin = false;
                this.preview_playing_flesh = false;
                this.preview_playing_bones = false;
            },
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        },
        props: {
            initiallyVisible: Boolean,
            viewed: Array,
            viewkey: String,
            resetCount: Number
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            visible: function(newVal, oldVal) {
                this.showContent = true;

                if(newVal){
                    this.$refs.fade_in.play();
                } else{
                    this.$refs.fade_out.play();
                }
            },
            viewkey: function() {
                if (this.viewed.indexOf(this.viewkey) >= 0) {
                    this.info = "you have played this combination";
                } else if(this.choices.length > 0){
                    this.info = this.choices.length+" audio layer"+(this.choices.length>1?"s":"")+" selected";
                } else {
                    this.info = "";
                }
            },
            resetCount: function(newVal, oldVal) {
                if(newVal !== oldVal){
                    this.preview_playing_bones = false;
                    this.preview_playing_flesh = false;
                    this.preview_playing_skin = false;
                    this.choices = [];
                    this.info = "";
                }
            }
        },
        data() {
            return {
                preview_playing_bones: false,
                preview_playing_flesh: false,
                preview_playing_skin: false,
                choices: [],
                visible: this.initiallyVisible,
                showContent: this.initiallyVisible,
                info: "",
                lastResetCount: 0,
                "keyframes_fadeout": {
                    // eslint-disable-next-line no-unused-vars
                    "#audiopage": i => ({
                        0: {
                            "opacity": 1
                        },
                        0.5: {
                            "opacity": 0
                        },
                        easing: "linear"
                    }),
                },
                "keyframes_fadein": {
                    // eslint-disable-next-line no-unused-vars
                    "#audiopage": i => ({
                        0: {
                            "opacity": 0
                        },
                        0.5: {
                            "opacity": 1
                        },
                        easing: "linear"
                    }),
                }
            };
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .audiopage{

        $audio-options-height: 214px;
        $audio-button-height: 150px;

        .instruction {
            position: absolute;
            top:calc((var(--vhc, 100vh) - #{$audio-options-height}) / 2 - (#{$audio-options-height} * 0.8));
            width: 100%;

            font-family: Lato;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            text-align: center;
            letter-spacing: 0.04em;

            color: #FFFFFF;

            @media only screen and (max-height : 580px) {
                top:calc((var(--vhc, 100vh) - 160px) / 2 - (160px));
                font-size: 18px;
            }
        }

        .headphones {
            position: absolute;
            top:calc((var(--vhc, 100vh) - #{$audio-options-height}) / 2 - (#{$audio-options-height} * 1.2));
            width: 100%;

            font-family: Lato;
            font-style: normal;
            font-weight: 300;
            font-size: 16px;
            text-align: center;
            letter-spacing: 0.04em;

            color: #fff;

            /* mobile */
            @media only screen and (max-width : 736px)  {
                //display: none;
            }

        }

        .info {
            position: absolute;
            top:calc((var(--vhc, 100vh) - #{$audio-options-height}) / 2 + (#{$audio-options-height} * 0.8));
            width: 100%;

            font-family: Lato;
            font-style: normal;
            font-weight: 300;
            font-size: 16px;
            text-align: center;
            letter-spacing: 0.04em;

            color: #fff;
        }

        .audiooptions {

            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-content: space-between;
            align-items: center;
            position: relative;
            top:calc(var(--vhc, 100vh) / 2 - #{$audio-options-height});
            @media only screen and (max-height : 580px) {
                top:calc(var(--vhc, 100vh) / 2 - 170px);
            }

            .audiooption {
                width: 380px;
                height: $audio-button-height;
                flex: 0 1 auto;
                align-self: auto;
                margin: 10px;
                background-position: center;
                background-size: cover;
                line-height: $audio-button-height;
                border: 2px solid #bdbdbd;
                background-color: #3e3c3c;

                font-family: Cormorant Garamond;
                font-style: normal;
                font-weight: 500;
                font-size: 40px;
                text-align: center;

                cursor: pointer;

                box-shadow: 0 0 0px #fff;
                transition: box-shadow 0.2s, border 0.2s;

                @media only screen and (max-height : 580px) {
                    height: 40px;
                    line-height: 40px;
                    font-size: 30px;
                }

                &:hover {
                    border: 2px solid #ffffff;
                    transition: box-shadow 0.2s, border 0.2s;
                }

                &.selected {
                    box-shadow: 0 0 19px #fff;
                    transition: box-shadow 0.2s;
                    border: 2px solid #ffffff;
                }
            }
        }

        $audio-preview-height: 30px;

        .audiopreviews {

            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-content: space-between;
            align-items: center;
            position: relative;
            top:calc(var(--vhc, 100vh) / 2 - 218px);
            @media only screen and (max-height : 580px) {
                top:calc(var(--vhc, 100vh) / 2 - 182px);
            }

            .audiopreview {
                width: 384px;
                height: $audio-preview-height;
                flex: 0 1 auto;
                align-self: auto;
                margin: 10px;
                background-position: center;
                line-height: $audio-preview-height;
            }
        }
    }

</style>
